import { CIcon } from '~/icons/types'

export const ciMarketplace: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.53 7.987V6.3c0-.181-.049-.36-.142-.515l-1.688-2.8a1 1 0 0 0-.857-.485H4.154a1 1 0 0 0-.857.485l-1.685 2.8a1 1 0 0 0-.142.515v1.687a2.5 2.5 0 0 0 1.588 2.3V19.5H2.47a1 1 0 0 0 0 2h19.06a1 1 0 0 0 0-2H21v-9.241a2.492 2.492 0 0 0 1.53-2.272Zm-6.353-.679h1.177v.683a.545.545 0 0 1-.583.494h-.013a.544.544 0 0 1-.581-.494v-.683Zm4.353 0v.679a.6.6 0 0 1-1.176 0v-.679h1.176ZM19.28 4.5l.486.808H4.234L4.72 4.5h14.56ZM13 7.308h1.177v.683a.544.544 0 0 1-.582.494h-.013A.544.544 0 0 1 13 7.991v-.683Zm-3.177 0H11v.683a.544.544 0 0 1-.582.494h-.013a.544.544 0 0 1-.582-.494v-.683Zm-5.177.679a.548.548 0 0 1-.594.494.544.544 0 0 1-.582-.494v-.679h1.176v.679Zm2 0v-.679h1.177v.683a.544.544 0 0 1-.582.494h-.013a.544.544 0 0 1-.582-.494v-.004ZM16 19.5h-1l.007-6.024h1L16 19.5Zm2 0 .008-7.023a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1L13 19.5H5.058v-9.212c.21-.088.406-.204.586-.343a2.61 2.61 0 0 0 1.584.54h.013a2.615 2.615 0 0 0 1.582-.537c.454.347 1.01.536 1.582.537h.013A2.615 2.615 0 0 0 12 9.948c.454.347 1.01.536 1.582.537h.018a2.618 2.618 0 0 0 1.582-.537c.454.347 1.01.536 1.581.537h.013a2.614 2.614 0 0 0 1.587-.541c.195.148.409.268.637.356v9.2h-1Z'
    },
    {
      d:
        'M11 11.473H7a1 1 0 0 0-1 1v5.2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-5.2a1 1 0 0 0-1-1Zm-1 5.2H8v-3.2h2v3.2Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'marketplace',
  type: 'regular'
}
